import { render, staticRenderFns } from "./UserAdditionalInfo.vue?vue&type=template&id=7ce84c64&scoped=true&"
import script from "./UserAdditionalInfo.vue?vue&type=script&lang=js&"
export * from "./UserAdditionalInfo.vue?vue&type=script&lang=js&"
import style0 from "./UserAdditionalInfo.vue?vue&type=style&index=0&id=7ce84c64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce84c64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
